export enum LocationUTM {
  Gclid = 'gclid',
  Tword = 'tword',
  UtmCampaign = 'utm_campaign',
  UtmContent = 'utm_content',
  UtmMedium = 'utm_medium',
  UtmSource = 'utm_source',
  UtmTerm = 'utm_term',
}
